import React from 'react';
import PropTypes from 'prop-types';

import './srOnly.scss';

export const SROnly = (props) => (
  <span className="sr-only">{props.children}</span>
);

SROnly.propTypes = {
    children: PropTypes.node.isRequired,
};

export default SROnly;
